module.exports = __webpack_public_path__ + "k-icons.1655747793800.woff2";